import AptoSDK, { IAuthOptions, InitOptions } from '@apto-payments/pci-sdk-web'

interface IData {
  apto_session_token: string
  apto_card_id: string
}

export const initializeAptoSdk = (data: IData) => {
	const element = document.getElementById('pci-sdk');
  if (!element)
    console.error('Apto SDK element not found');

	const options: InitOptions = {
		auth: {
			userToken: data?.apto_session_token,
			cardId: data?.apto_card_id,
			apiKey: process.env.NEXT_PUBLIC_APTO_SDK_API_KEY!,
			environment: process.env.NEXT_PUBLIC_APTO_SDK_ENV as IAuthOptions["environment"],
		},
		element,
	}
	console.log(process.env.NEXT_PUBLIC_APTO_SDK_ENV)
	console.log(process.env.NEXT_PUBLIC_APTO_SDK_API_KEY)

	AptoSDK.init(options)
	AptoSDK.showSetPinForm()
	AptoSDK.setStyle({
		extends: 'light',
		notification: {
			positive: {
				borderRadius: 0,
				backgroundColor: '#33DE71',
			},
			negative: {
				borderRadius: 0,
				backgroundColor: '#DE5233',
			},
		},
	})
}
